import React, { useState } from 'react';
import { FaBars, FaHome, FaUserCircle } from 'react-icons/fa';
import './AuthenticatedHeader.scss';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AuthenticatedHeader: React.FC = () => {
  const { isAdmin } = useAuth();
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const closeDropdown = () => {
    setDropdownOpen(false);
  };

  return (
    <header className="header">
      <div className="header__left">
        <div id="full-menu">
          <Link to={'/dashboard'} className="header__link header__primary">
            <FaHome className="header__icon" />
            Home
          </Link>
          {/*
          <Link to={'/teams'} className="header__link">
            Teams
          </Link>*/}
          {isAdmin && (
            <Link to={'/admin/users'} className="header__link">
              Users
            </Link>
          )}
          <Link to={'/help'} className="header__link">
            Help
          </Link>
        </div>
        <div id="mini-menu">
          <button className="header__dropdown-toggle" onClick={toggleDropdown}>
            <FaBars className="header__icon" />
          </button>
          {isDropdownOpen && (
            <div className="header__dropdown-menu">
              <Link
                to={'/dashboard'}
                className="header__link"
                onClick={closeDropdown}
                onKeyDown={(e) => e.key === 'Enter' && closeDropdown}
              >
                Home
              </Link>
              {/*
              <Link
                to={'/teams'}
                className="header__link"
                onClick={closeDropdown}
                onKeyDown={(e) => e.key === 'Enter' && closeDropdown}
              >
                Teams
              </Link>*/}
              {isAdmin && (
                <Link
                  to={'/admin/users'}
                  className="header__link"
                  onClick={closeDropdown}
                  onKeyDown={(e) => e.key === 'Enter' && closeDropdown}
                >
                  Users
                </Link>
              )}
              <Link
                to={'/help'}
                className="header__link"
                onClick={closeDropdown}
                onKeyDown={(e) => e.key === 'Enter' && closeDropdown}
              >
                Help
              </Link>
            </div>
          )}
        </div>
      </div>
      <div className="header__right">
        <Link to={'/account/details'} className="header__link">
          My Account
          <FaUserCircle className="header__icon--right" />
        </Link>
      </div>
    </header>
  );
};

export default AuthenticatedHeader;
